import { MessagesPropsWrapper } from "../../common/types";
import Message from "../Message";
import styles from "./Messages.module.scss";

const Messages = ({ contentArray }: MessagesPropsWrapper) => {
  return (
    <main className={styles.messagesContainer}>
      {contentArray.map((message, index) => (
        <Message key={`message-${index}`} content={message} />
      ))}
    </main>
  );
};

export default Messages;
